/** Frequently asked questions, one list per audience. Each list is shown at the end of that audience's guide page. */

export const FAQ_START: [string, string][] = [
  ['Ali moram imeti račun, da preberem razpis?', 'Ne. Javna stran razpisa in ta navodila so odprta vsem. Račun potrebujete šele za prijavo na tekmovanje.'],
  [
    'Kako se prijavim na tekmovanje?',
    'Odprite povezavo na razpis, ki jo dobite od organizatorja, ustvarite račun (ali se prijavite) in pritisnite »Prijavi se na tekmovanje«. Takoj lahko oddajate prispevke.',
  ],
  [
    'Zakaj ne vidim gumba za prijavo na tekmovanje?',
    'Organizator je prijave zaprl ali pa ste že prijavljeni.',
  ],
  [
    'Vidim, da tekmovanje obstaja, a ne vidim prispevkov.',
    'Vsebino tekmovanja vidijo samo prijavljeni tekmovalci, sodniki in organizatorji. Prijavite se prek povezave na razpis.',
  ],
  [
    'Pozabil sem geslo ali povezava za geslo ne deluje.',
    'Na prijavni strani izberite »Pozabljeno geslo« in vpišite e-pošto. Povezava velja eno uro (povabilo sedem dni) in jo lahko uporabite samo enkrat. Če je potekla, zahtevajte novo.',
  ],
  [
    'Kako spremenim e-naslov ali geslo?',
    'Na strani »Moj račun«. Za spremembo gesla morate vpisati trenutno geslo, ob spremembi e-naslova pa obvestilo prejme stari naslov.',
  ],
];

export const FAQ_COMPETITOR: [string, string][] = [
  [
    'Plačal sem z nakazilom, a ne vidim oznake »Plačano«.',
    'Bančna nakazila označi organizator ročno, ko plačilo prispe, kar lahko traja nekaj dni. Plačilo s kartico se označi samo.',
  ],
  [
    'Zakaj ne morem oddati slike?',
    'Tekmovanje mora biti v stanju »Aktivno« in rok za oddajo ne sme biti pretečen. Preverite tudi, ali ste v tej kategoriji že porabili dovoljeno število prispevkov.',
  ],
  [
    'Slika je bila zavrnjena ali ima opozorilo. Kaj naj naredim?',
    'Preberite razlog: pove, kaj ne ustreza zahtevam (format, velikost datoteke, dolžina daljše stranice, ločljivost ali EXIF). Sliko popravite, izbrišite stari prispevek in naložite novega, dokler organizator prispevka ni sprejel ali zavrnil.',
  ],
  [
    'Kako preverim ločljivost (dpi) in EXIF svoje slike?',
    'V programu za urejanje slik (Lightroom, Photoshop, GIMP) pri izvozu nastavite velikost daljše stranice in ločljivost. Podatke EXIF obdržite tako, da ob izvozu ne izberete možnosti »odstrani metapodatke«.',
  ],
  ['Ali lahko prispevek po oddaji preimenujem ali zamenjam sliko?', 'Da, dokler ga organizator ni sprejel ali zavrnil. Potem sprememb ni več.'],
  ['Kdaj vidim ocene in mesto?', 'Ko je tekmovanje zaključeno, pod »Moji rezultati«. Prej se prikaže obvestilo, da rezultati še niso objavljeni.'],
  [
    'Zakaj imata dva prispevka isto mesto?',
    'Enaka povprečna ocena pomeni skupno mesto. Kdo prejme nagrado, ko je več prispevkov izenačenih, odloči žirija.',
  ],
  [
    'Ali drugi tekmovalci vidijo moje ocene?',
    'Ne. Vsak vidi samo svoje rezultate, in to šele po zaključku tekmovanja.',
  ],
];

export const FAQ_JUDGE: [string, string][] = [
  ['Zakaj ne vidim razvrstitve?', 'Razvrstitev je vidna šele, ko je tekmovanje zaključeno, da se sodniki med ocenjevanjem ne vplivajo drug na drugega.'],
  ['Zakaj ne morem ocenjevati?', 'Ocenjevati je mogoče samo, ko je tekmovanje v stanju »Ocenjevanje« in ko je prispevek sprejet.'],
  ['Ali drugi sodniki vidijo mojo oceno?', 'Ne. Ocene in komentarji posameznega sodnika so skriti drugim sodnikom in avtorjem, dokler tekmovanje ni zaključeno.'],
  [
    'Kaj pomeni oznaka »Izenačeno«?',
    'Dva ali več prispevkov ima enako povprečno oceno in si deli mesto. O nagradi odloči žirija, organizator pa nagrado podeli izbranemu prispevku.',
  ],
];

export const FAQ_ORGANIZER: [string, string][] = [
  [
    'Zakaj ne morem začeti ocenjevanja?',
    'Vsaj en prispevek mora biti oddan in ne zavrnjen. Prispevkov ni treba posebej sprejemati: ob začetku ocenjevanja so sprejeti vsi, ki jih niste zavrnili.',
  ],
  [
    'Kako podelim nagrado izenačenima prispevkoma?',
    'Žirija odloči izven aplikacije, vi pa na strani »Nagrade« nagrado podelite izbranemu prispevku. Nagrade lahko podelite, ko je ocenjevanje zaključeno (stanje »Podeljevanje nagrad«); tekmovalci jih vidijo šele, ko objavite rezultate.',
  ],
  [
    'Kako izberem prispevke za razstavo?',
    'Ko zaključite ocenjevanje, na strani »Nagrade« pri »Izbor za razstavo« izberete delež (običajno 20 do 35 %) ali število najboljših in ali to velja v vsaki kategoriji posebej ali skupaj po oceni, nato pritisnete »Izberi najboljše«. Izbrane fotografije nato vidite na strani tekmovanja z gumbom »Izbrani za razstavo«.',
  ],
  [
    'Slika ne ustreza zahtevam, a sem jo pustil v tekmovanju. Kaj zdaj?',
    'Če ste izbrali »Sprejmi in označi«, prispevek ostane z opozorilom. Odprite ga in pritisnite »Zavrni fotografijo«: razlog je že vpisan, lahko ga dopolnite.',
  ],
  [
    'Kako dodam tekmovalca ali sodnika, ki še nima računa?',
    'Pri tekmovalcih ali sodnikih vnesite e-pošto, ime in priimek. Oseba prejme povabilo s povezavo, kjer sama izbere geslo. Gesla ne nastavljate vi.',
  ],
  [
    'Kako zaprem ali odprem prijave?',
    'Na strani »Tekmovalci« pritisnite »Zapri prijave« oziroma »Odpri prijave«. Prijave, ki so že oddane, ostanejo.',
  ],
  [
    'Zakaj ne morem urejati tekmovanja?',
    'Zaključenega in arhiviranega tekmovanja ni več mogoče urejati. Zaključeno tekmovanje lahko vrnete na podeljevanje nagrad ali na aktivno.',
  ],
  [
    'Zakaj tekmovalci ne vidijo plačila?',
    'Plačilo se pokaže šele, ko pri »Plačila« vpišete kotizacijo in vklopite vsaj en način (QR kodo ali kartico).',
  ],
  [
    'Plačilo s kartico mine, a oznaka »Plačano« se ne pojavi.',
    'Ko se tekmovalec po plačilu vrne na stran tekmovanja, Zaslonka plačilo preveri pri Stripe in ga označi sama. Webhook je potreben le, če tekmovalec okno zapre pred vrnitvijo. Preverite, da je naslov webhooka v Stripe enak tistemu na strani »Plačila«, da sta izbrana oba dogodka in da ste vpisali pravo podpisno skrivnost (whsec_…). V Stripe pri webhooku vidite, ali je strežnik odgovoril. Oznako lahko vmes nastavite ročno. Pri lokalnem preizkusu Stripe ne more klicati računalnika doma, zato webhook tam ne deluje.',
  ],
  [
    'Kako delim javno stran razpisa?',
    'Pri tekmovanju pritisnite »Razpis« in »Ogled javne strani«, nato kopirajte naslov (/razpis/…) in ga objavite na spletni strani ali v družbenih omrežjih.',
  ],
];
